import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ApiService } from './api.service';
import { AppConfig } from './app-config.service';
import { saveAs } from 'file-saver';
import { catchError, switchMap } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataExportService {

  constructor(private http: HttpClient,
              private api: ApiService,
              private appConfig: AppConfig) {
  }

  public fetchCustomerExportedData(): Observable<void> {
    return this.http
      .get<Blob>(this.appConfig.config.apiUrl + `/customer-data-export`, {
        observe: 'response',
        responseType: 'blob' as 'json',
      })
      .pipe(
        switchMap((res: HttpResponse<Blob>) => {
          const fileName = res?.headers.get('content-disposition')?.split('filename=')?.[1];
          saveAs(res.body, fileName ?? 'Dane użytkownika.xlsx');
          return of(void 0);
        }),
        catchError(() => throwError('Export error'))
      );
  }
}

